import {
  Bleed,
  Box,
  Card,
  Dialog,
  IconChevronRight,
  Pressable,
  ResponsiveRender,
  Stack,
  Text
} from '@machobear/design-system'
import { useTranslation } from 'react-i18next'
import { vars } from '@machobear/design-system/css'
import { useHistory } from 'react-router'
import { DialogEventHandler } from '@/types'
import LivApplication from './illustration/liv-application.svg?react'
import ExternalApplication from './illustration/external-application.svg?react'

type Props = {
  showModal: DialogEventHandler
  visible: boolean
  closeModal: DialogEventHandler
}

const TenantScreeningOptions = ({ showModal, visible, closeModal }: Props) => {
  const { t } = useTranslation()
  const history = useHistory()

  const handleLivApplication = () => {
    showModal()
    closeModal()
  }

  const handleExternalApplication = () => {
    history.push('/trust-score/credit-check')
  }

  const cardItems = [
    {
      title: t('l.credit_usage.liv_application.title', 'Select an application'),
      description: t(
        'l.credit_usage.liv_application.text',
        'Screen tenants that have applied to your listing.'
      ),
      backgroundColor: vars.backgroundColor.criticalSoft,
      illustration: <LivApplication />,
      onClick: handleLivApplication
    },
    {
      title: t('l.credit_usage.external_application.title', 'Enter tenant information'),
      description: t(
        'l.credit_usage.external_liv_application.text',
        'Screen tenants that have applied outside of liv.rent.'
      ),
      backgroundColor: vars.backgroundColor.formAccentSoft,
      illustration: <ExternalApplication />,
      onClick: handleExternalApplication
    }
  ]

  return (
    <Dialog
      id="tenantScreeningOptionsModal"
      title={t('b.usage.dialog.tenant_screening_report.title', 'Tenant Screening Report')}
      open={visible}
      onClose={closeModal}
    >
      <Text size="medium" weight="regular">
        {t(
          'b.usage.dialog.start_screening.title',
          'Start screening by selecting one of the options below:'
        )}
      </Text>
      <Box style={{ paddingTop: '24px' }}>
        <Stack space="small">
          {cardItems.map((item, index) => (
            <Pressable borderRadius="large" onClick={item.onClick} key={index}>
              <Card rounded>
                <Box display="flex" alignItems="center">
                  <ResponsiveRender above="mobile">
                    <Bleed left="medium" vertical="medium">
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        margin="none"
                        marginRight="large"
                        borderRadius="large"
                        style={{
                          height: 89,
                          width: 89,
                          backgroundColor: item.backgroundColor
                        }}
                      >
                        {item.illustration}
                      </Box>
                    </Bleed>
                  </ResponsiveRender>
                  <Bleed horizontal="xsmall" vertical="xsmall">
                    <Stack space="small">
                      <Text weight="strong">
                        {item.title} <IconChevronRight />
                      </Text>
                      <Text>{item.description}</Text>
                    </Stack>
                  </Bleed>
                </Box>
              </Card>
            </Pressable>
          ))}
        </Stack>
      </Box>
    </Dialog>
  )
}

export default TenantScreeningOptions
